import type { DiscoverItem } from "../types";

/**
 * Match each whitespace-separated token independently so multi-word queries
 * like "quad agadir" hit an item titled "Quad Biking" located in "Agadir": the
 * words need not be adjacent. City/category slugs are part of the haystack so
 * a place or theme name matches even when it only lives in the URL slug. The
 * tab counts use the same test, so a tab never promises rows the search hides.
 */
export function matchesSearch(item: DiscoverItem, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (q.length === 0) return true;
  const haystack =
    `${item.title} ${item.subtitle} ${item.location} ${item.description} ${item.citySlug ?? ""} ${item.categorySlug ?? ""}`.toLowerCase();
  return q.split(/\s+/).filter(Boolean).every((token) => haystack.includes(token));
}
